import React, { useState } from "react";
import { Badge } from "antd";
import CustomTabs from "components/tabs/customTab";
import PendingLeaveRequestCard from "./PendingLeaveRequestCard";
import ApprovedLeaveRequestCard from "./ApprovedLeaveRequestCard";
import RejectedLeaveRequestCard from "./RejectedLeaveRequestCard";

const pendingLeaves = [
  {
    name: "Jennifer Lee",
    role: "Senior Developer",
    leaveType: "Annual Leave",
    employeeId: "EMP001",
    startDate: "Nov 1, 2025",
    endDate: "Nov 10, 2025",
    days: 10,
    reason: "Family vacation trip",
    dateRequested: "Oct 10, 2025",
  },
  {
    name: "Robert Taylor",
    role: "Frontend Developer",
    leaveType: "Sick Leave",
    startDate: "Oct 15, 2025",
    employeeId: "EMP003",
    endDate: "Oct 15, 2025",
    days: 1,
    reason: "Extra project hours",
    dateRequested: "Oct 13, 2025",
  },
    {
    name: "Emily Rodriguez",
    role: "DevOps Engineer",
    leaveType: "Emergency Leave",
    startDate: "Oct 15, 2025",
    employeeId: "EMP002",
    endDate: "Oct 15, 2025",
    days: 1,
    reason: "Personal matters",
    dateRequested: "Oct 13, 2025",
  },
];

const approvedLeaves = [
  {
    name: "Alice Johnson",
    role: "Software Engineer",
    duration: "5 days",
    leavePeriod: "Nov 1, 2025 - Nov 5, 2025",
    approvedBy: "HR Manager",
    leaveType: "Vacation",
    approvalDate: "Oct 15, 2025",
    employeeId: "EMP001",
  },
  {
    name: "Michael Brown",
    role: "Project Manager",
    duration: "2 days",
    leavePeriod: "Oct 20, 2025 - Oct 21, 2025",
    approvedBy: "HR Manager",
    leaveType: "Personal",
    approvalDate: "Oct 18, 2025",
    employeeId: "EMP002",
  },
  {
    name: "Sophia Davis",
    role: "UX Designer",
    duration: "3 days",
    leavePeriod: "Oct 12, 2025 - Oct 14, 2025",
    approvedBy: "HR Manager",
    leaveType: "Sick Leave",
    approvalDate: "Oct 10, 2025",
    employeeId: "EMP003",
  },
];

const rejectedLeaves = [
  {
    name: "Alice Johnson",
    role: "Software Engineer",
    duration: "5 days",
    leavePeriod: "Nov 1, 2025 - Nov 5, 2025",
    rejectedBy: "HR Manager",
    leaveType: "Vacation",
    rejectedDate: "Oct 15, 2025",
    employeeId: "EMP001",
    reason: "Insufficient notice period"
  },
  {
    name: "Sophia Davis",
    role: "UX Designer",
    duration: "3 days",
    leavePeriod: "Oct 12, 2025 - Oct 14, 2025",
    rejectedBy: "HR Manager",
    leaveType: "Sick Leave",
    rejectedDate: "Oct 10, 2025",
    employeeId: "EMP003",
    reason: "Insufficient notice period"
  },
];

const TabLabel = ({ text, count }) => {
  const isPending = text === "Pending";
  return (
    <div className="flex items-center justify-center gap-2">
      <span className="text-sm font-medium">{text}</span>
      <Badge
        count={count}
        style={
          isPending
            ? {}
            : {
                backgroundColor: "#FFFFFF",
                color: "#000000",
                border: "1px solid #d9d9d9",
              }
        }
      />
    </div>
  );
};

const LeaveRequestTab = () => {
  const [activeTab, setActiveTab] = useState("Pending");

  const tabOptions = [
    { label: <TabLabel text="Pending" count={pendingLeaves.length} />, value: "Pending" },
    { label: <TabLabel text="Approved" count={approvedLeaves.length} />, value: "Approved" },
    { label: <TabLabel text="Rejected" count={rejectedLeaves.length} />, value: "Rejected" },
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />

      <div className="mt-4 space-y-4 max-h-[600px] overflow-y-auto">
        {activeTab === "Pending" &&
          pendingLeaves.map((leave, index) => (
            <PendingLeaveRequestCard key={index} {...leave} />
          ))}
        {activeTab === "Approved" && 
          approvedLeaves.map((leave, index) => (
            <ApprovedLeaveRequestCard key={index} {...leave} />
          ))}
        {activeTab === "Rejected" && 
          rejectedLeaves.map((leave, index) => (
            <RejectedLeaveRequestCard key={index} {...leave} />
          ))}
      </div>
    </div>
  );
};

export default LeaveRequestTab;
